// extracted by mini-css-extract-plugin
module.exports = {"White":"#FFFFFF","Top":"10000","wrapper":"OptionsWrapper_wrapper__3uHIn","isExpanded":"OptionsWrapper_isExpanded__1Kbmt"};